import moment from "moment";
import { httpApi } from "api/http.api";
import { IClient, IClientUser, IClientUserById, IClientUserByIdResponse, IClientUserResponse, ModulesResponse, UserRequestV1, UserResponse } from "domain/ClientInterfacesV1";
import { AxiosResponse } from "axios";

export const getClientUserListV1 = (): Promise<IClientUserById[]> =>
  httpApi
    .get<IClientUserByIdResponse>("Users/GetClientUsers/V2")
    .then((response: AxiosResponse<IClientUserByIdResponse>) => {
      return response.data.data;
    });

export const addClientUser = (garmentsPayload: IClientUser): Promise<IClientUserResponse> =>
  httpApi
    .post<IClientUserResponse>("Users/AddClientUser/V2", {
      ...garmentsPayload,
    })
    .then(({ data }) => data);

export const updateClientUser = (
  id: string,
  userPayload: IClientUser
): Promise<IClientUserResponse> =>
  httpApi
    .put<IClientUserResponse>(`Users/${id}/UpdateClientUser/V2`, {
      ...userPayload,
    })
    .then(({ data }) => data);

export const getUserById = (id: string): Promise<IClientUserById> =>
  httpApi
    .get<{ data: IClientUserById[] }>(`Users/${id}/GetClientUser/V2`)
    .then(({ data }) => data["data"][0])
    .then((data) => data);

export const activateUser = (id: string): Promise<UserResponse> =>
  httpApi
    .put<UserRequestV1>(`Users/${id}/ActivateUser`, {})
    .then(({ data }) => data);

export const deActivate = async (id: string): Promise<UserResponse> => {
  let time = moment().toISOString();
  let hmac_token = await httpApi.delete<UserResponse>(
    `Users/${id}/DeactivateUser`,
    {
      data: { hmac_time: time },
    }
  );

  return httpApi.delete(`Users/${id}/DeactivateUser`, {
    data: { hmac_time: time, hmac: hmac_token?.data?.hmac },
  });
};

export const deleteUserV1 = async (id: string): Promise<UserResponse> => {
  let time = moment().toISOString();
  let hmac_token = await httpApi.delete<UserResponse>(
    `Users/${id}/DeleteClientUser/V2`,
    {
      data: { hmac_time: time },
    }
  );
  const response = await httpApi.delete<UserResponse>(`Users/${id}/DeleteClientUser/V2`, {
    data: { hmac_time: time, hmac: hmac_token?.data?.hmac },
  });
  return response.data;
};

export const getClientList = (): Promise<IClient[]> =>
  httpApi.get<IClient[]>("Clients?show_active=true").then(({ data }) => data);

export const GetClientModules = (): Promise<ModulesResponse> =>
  httpApi.get<ModulesResponse>("Users/GetClientModules").then(({ data }) => data);